import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { Store } from "pullstate";
import { approveMachines, approveUsers, getMachinesAndUsers, hasNextPage, hasPrevPage, revokeMachines, revokeUsers, deleteMachines, deleteUsers } from "../utils/adminView";
import Toast from "../components/Toast";
import { enableMapSet } from "immer";
enableMapSet();
var AdminViewStore = new Store({
  view: "users",
  data: null,
  viewData: {
    workspace: null,
    selectedRows: [],
    allRowsSelected: false,
    currentPage: 1,
    maxRowsPerPage: 25,
    rowsInCurrentPage: []
  },
  metadata: {
    lastFetch: null,
    dataVersion: 0,
    isDirty: false
  },
  filters: {
    status: [],
    search: {
      userquery: "",
      hostname: ""
    },
    sorting: {
      field: "createdAt",
      direction: "desc"
    }
  },
  realtime: {
    newUsersCount: 0,
    newMachinesCount: 0,
    highlightedUsers: new Set(),
    highlightedMachines: new Set(),
    pollingInterval: 30000,
    isPolling: false,
    hasPollingStarted: false
  },
  computed: {
    filteredData: [],
    filteredCount: 0,
    currentPageData: [],
    hasFiltersApplied: false,
    selectedValidItems: [],
    actionCounts: {
      canApprove: 0,
      canRevoke: 0,
      canDelete: 0
    }
  }
});
var AdminRealTimeManager = /*#__PURE__*/function () {
  function AdminRealTimeManager() {
    _classCallCheck(this, AdminRealTimeManager);
    _defineProperty(this, "pollingInterval", null);
    _defineProperty(this, "isActive", false);
  }
  return _createClass(AdminRealTimeManager, [{
    key: "start",
    value: function start(workspace, dispatch) {
      if (this.isActive) return;
      this.isActive = true;
      AdminViewStore.update(function (s) {
        s.realtime.isPolling = true;
      });
      this.poll(workspace, dispatch);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isActive = false;
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      AdminViewStore.update(function (s) {
        s.realtime.isPolling = false;
      });
    }
  }, {
    key: "poll",
    value: function () {
      var _poll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(workspace, dispatch) {
        var _this = this;
        var _freshData$, _freshData$2, currentState, previousData, freshData, newData, state, changes, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.isActive) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              currentState = AdminViewStore.getRawState();
              previousData = currentState.data;
              _context.n = 2;
              return getMachinesAndUsers(workspace.value);
            case 2:
              freshData = _context.v;
              newData = {
                users: (_freshData$ = freshData[0]) === null || _freshData$ === void 0 ? void 0 : _freshData$.value,
                machines: (_freshData$2 = freshData[1]) === null || _freshData$2 === void 0 ? void 0 : _freshData$2.value
              };
              state = AdminViewStore.getRawState();
              changes = this.detectChanges(previousData, newData);
              if (changes.hasChanges && currentState.realtime.hasPollingStarted) {
                if (document.visibilityState === "visible") {
                  if (state.view === "users") {
                    updateWithRecompute(function (s) {
                      s.realtime.highlightedUsers = new Set();
                    });
                  } else if (state.view === "machines") {
                    updateWithRecompute(function (s) {
                      s.realtime.highlightedMachines = new Set();
                    });
                  }
                }
                updateWithRecompute(function (s) {
                  var _s$metadata;
                  s.data = newData;
                  s.realtime.newUsersCount = changes.newUsersCount;
                  s.realtime.newMachinesCount = changes.newMachinesCount;
                  s.realtime.highlightedUsers = new Set([].concat(_toConsumableArray(s.realtime.highlightedUsers), _toConsumableArray(changes.newUsersIds.map(function (id) {
                    return id;
                  }))));
                  s.realtime.highlightedMachines = new Set([].concat(_toConsumableArray(s.realtime.highlightedMachines), _toConsumableArray(changes.newMachinesIds.map(function (id) {
                    return id;
                  }))));
                  s.metadata.lastFetch = new Date();
                  (_s$metadata = s.metadata) !== null && _s$metadata !== void 0 && _s$metadata.dataVersion ? s.metadata.dataVersion += 1 : s.metadata.dataVersion = 1;
                });
                if (changes.newUsersCount > 0) {
                  Toast.success("".concat(changes.newUsersCount, " new users have been added"));
                }
                if (changes.newMachinesCount > 0) {
                  Toast.success("".concat(changes.newMachinesCount, " new machines have been added"));
                }
              }
              if (state.realtime.isPolling) {
                this.pollingInterval = setTimeout(function () {
                  return _this.poll(workspace, dispatch);
                }, state.realtime.pollingInterval);
              }
              if (!state.realtime.hasPollingStarted) {
                AdminViewStore.update(function (s) {
                  s.realtime.hasPollingStarted = true;
                });
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error("Error polling for realtime data", _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function poll(_x, _x2) {
        return _poll.apply(this, arguments);
      }
      return poll;
    }()
  }, {
    key: "detectChanges",
    value: function detectChanges(previousData, newData) {
      var _previousData$users, _previousData$machine, _newData$users3, _newData$machines3;
      if (!previousData) {
        var _newData$users, _newData$machines, _newData$users2, _newData$machines2;
        return {
          hasChanges: true,
          newUsersCount: ((_newData$users = newData.users) === null || _newData$users === void 0 ? void 0 : _newData$users.length) || 0,
          newMachinesCount: ((_newData$machines = newData.machines) === null || _newData$machines === void 0 ? void 0 : _newData$machines.length) || 0,
          newUsersIds: ((_newData$users2 = newData.users) === null || _newData$users2 === void 0 ? void 0 : _newData$users2.map(function (user) {
            return user.id;
          })) || [],
          newMachinesIds: ((_newData$machines2 = newData.machines) === null || _newData$machines2 === void 0 ? void 0 : _newData$machines2.map(function (machine) {
            return machine.id;
          })) || []
        };
      }
      var oldUsersIds = new Set(((_previousData$users = previousData.users) === null || _previousData$users === void 0 ? void 0 : _previousData$users.map(function (user) {
        return user.id;
      })) || []);
      var oldMachinesIds = new Set(((_previousData$machine = previousData.machines) === null || _previousData$machine === void 0 ? void 0 : _previousData$machine.map(function (machine) {
        return machine.id;
      })) || []);
      var newUsersIds = ((_newData$users3 = newData.users) === null || _newData$users3 === void 0 ? void 0 : _newData$users3.filter(function (user) {
        return !oldUsersIds.has(user.id);
      }).map(function (user) {
        return user.id;
      })) || [];
      var newMachinesIds = ((_newData$machines3 = newData.machines) === null || _newData$machines3 === void 0 ? void 0 : _newData$machines3.filter(function (machine) {
        return !oldMachinesIds.has(machine.id);
      }).map(function (machine) {
        return machine.id;
      })) || [];
      var hasChanges = newUsersIds.length > 0 || newMachinesIds.length > 0;
      return {
        hasChanges: hasChanges,
        newUsersCount: newUsersIds.length,
        newMachinesCount: newMachinesIds.length,
        newUsersIds: newUsersIds,
        newMachinesIds: newMachinesIds
      };
    }
  }]);
}();
function recomputeDerivedData(state) {
  var _state$data;
  var currentData = ((_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data[state.view]) || [];
  var filteredData = applyFilters(currentData, state.filters);
  var sortedData = applySorting(filteredData, state.filters.sorting);
  var currentPageData = applyPagination(sortedData, state.viewData.currentPage, state.viewData.maxRowsPerPage);
  var selectedValidItems = filteredData.filter(function (item) {
    return state.viewData.selectedRows.includes(item.id);
  });
  return {
    filteredData: filteredData,
    filteredCount: filteredData.length,
    currentPageData: currentPageData,
    hasFiltersApplied: state.filters.status.length > 0 || state.filters.search.userquery !== "" || state.filters.search.hostname !== "",
    selectedValidItems: selectedValidItems,
    actionCounts: {
      canApprove: selectedValidItems.filter(function (item) {
        return item.approved === "PENDING";
      }).length,
      canRevoke: selectedValidItems.filter(function (item) {
        return item.approved === "APPROVED";
      }).length,
      canDelete: selectedValidItems.length
    }
  };
}
function updateWithRecompute(updateFn) {
  AdminViewStore.update(function (s) {
    updateFn(s);
    s.computed = recomputeDerivedData(s);
  });
}
var realTimeManager = new AdminRealTimeManager();
function reducer(action) {
  if (action.type === "get-data") {
    var state = AdminViewStore.getRawState();
    var viewData = state.viewData;
    var workspace = viewData.workspace;
    var value = workspace.value;
    getMachinesAndUsers(value).then(function (data) {
      updateWithRecompute(function (s) {
        s.data = {
          users: data[0].value,
          machines: data[1].value
        };
      });
    })["catch"](function (e) {
      Toast.error("Unable to get users and machines of workspace");
    });
  } else if (action.type === "set-workspace-data") {
    var _workspace = action.payload.workspace;
    updateWithRecompute(function (s) {
      s.viewData.workspace = _objectSpread({}, _workspace);
      s.realtime.hasPollingStarted = false;
    });
    // nested action
    reducer({
      type: "get-data"
    });
  } else if (action.type === "set-view") {
    updateWithRecompute(function (s) {
      s.view = action.payload.view;
      s.viewData = _objectSpread(_objectSpread({}, s.viewData), {}, {
        allRowsSelected: false,
        selectedRows: [],
        currentPage: 1
      });
      s.filters = _objectSpread(_objectSpread({}, s.filters), {}, {
        status: [],
        search: {
          userquery: "",
          hostname: ""
        }
      });
    });
  } else if (action.type === "record-row-selection") {
    var _action$payload = action.payload,
      id = _action$payload.id,
      level = _action$payload.level;
    var _state = AdminViewStore.getRawState();
    var activeView = _state.view;
    if (!_state.data) {
      console.warn("something awfully wrong has happened");
      return;
    }
    var activeViewData = _state.data[activeView];
    var allIds = activeViewData.map(function (x) {
      return x.id;
    });
    if (level === "column") {
      // see if the length of selected ids equals the length of all ids
      // if so, it is a signal to uncheck all of them.
      // if not, go ahead and add all ids to the list of selected ids;
      var compareIds = _state.computed.filteredData.map(function (x) {
        return x.id;
      });
      var haveEqualLengths = compareIds.length === _state.viewData.selectedRows.length;
      updateWithRecompute(function (s) {
        s.viewData.selectedRows = haveEqualLengths ? [] : compareIds;
        s.viewData.allRowsSelected = !haveEqualLengths;
      });
    } else if (level === "row") {
      // if the id is already present in the list - pop it
      // if not, add it
      var isPresent = _state.viewData.selectedRows.includes(id);
      var newRows = isPresent ? _state.viewData.selectedRows.filter(function (x) {
        return x !== id;
      }) : function () {
        var a = _state.viewData.selectedRows.map(function (x) {
          return x;
        });
        a.push(id);
        return a;
      }();
      updateWithRecompute(function (s) {
        s.viewData = _objectSpread(_objectSpread({}, s.viewData), {}, {
          selectedRows: newRows,
          allRowsSelected: newRows.length === allIds.length
        });
      });
    }
  } else if (action.type === "approve") {
    var _state2 = AdminViewStore.getRawState();
    if (_state2.view === "users") {
      var _state2$viewData$work;
      approveUsers((_state2$viewData$work = _state2.viewData.workspace) === null || _state2$viewData$work === void 0 ? void 0 : _state2$viewData$work.value, _state2.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value;
            successfulIds.push(_state2.viewData.selectedRows[idx]);
            var responseMessage = (response === null || response === void 0 || (_response$value = response.value) === null || _response$value === void 0 ? void 0 : _response$value.message) || "User approved successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve one or more users");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state2.viewData.currentPage;
          });
        }
      });
    } else if (_state2.view === "machines") {
      var _state2$viewData$work2;
      approveMachines((_state2$viewData$work2 = _state2.viewData.workspace) === null || _state2$viewData$work2 === void 0 ? void 0 : _state2$viewData$work2.value, _state2.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value2;
            successfulIds.push(_state2.viewData.selectedRows[idx]);
            var responseMessage = (response === null || response === void 0 || (_response$value2 = response.value) === null || _response$value2 === void 0 ? void 0 : _response$value2.message) || "System approved successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve one or more systems");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state2.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "revoke") {
    var _state3 = AdminViewStore.getRawState();
    if (_state3.view === "users") {
      var _state3$viewData$work;
      revokeUsers((_state3$viewData$work = _state3.viewData.workspace) === null || _state3$viewData$work === void 0 ? void 0 : _state3$viewData$work.value, _state3.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value3;
            successfulIds.push(_state3.viewData.selectedRows[idx]);
            var responseMessage = (response === null || response === void 0 || (_response$value3 = response.value) === null || _response$value3 === void 0 ? void 0 : _response$value3.message) || "User rejected successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject one or more users");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state3.viewData.currentPage;
          });
        }
      });
    } else if (_state3.view === "machines") {
      var _state3$viewData$work2;
      revokeMachines((_state3$viewData$work2 = _state3.viewData.workspace) === null || _state3$viewData$work2 === void 0 ? void 0 : _state3$viewData$work2.value, _state3.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value4;
            successfulIds.push(_state3.viewData.selectedRows[idx]);
            var responseMessage = (response === null || response === void 0 || (_response$value4 = response.value) === null || _response$value4 === void 0 ? void 0 : _response$value4.message) || "System rejected successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject one or more systems");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state3.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "delete") {
    var _state4 = AdminViewStore.getRawState();
    if (_state4.view === "users") {
      var _state4$viewData$work;
      deleteUsers((_state4$viewData$work = _state4.viewData.workspace) === null || _state4$viewData$work === void 0 ? void 0 : _state4$viewData$work.value, _state4.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value5;
            successfulIds.push(_state4.viewData.selectedRows[idx]);
            var responseMessage = (response === null || response === void 0 || (_response$value5 = response.value) === null || _response$value5 === void 0 ? void 0 : _response$value5.message) || "User deleted successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to delete one or more users");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "delete-row",
            payload: {
              ids: successfulIds
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state4.viewData.currentPage;
          });
        }
      });
    } else if (_state4.view === "machines") {
      var _state4$viewData$work2;
      deleteMachines((_state4$viewData$work2 = _state4.viewData.workspace) === null || _state4$viewData$work2 === void 0 ? void 0 : _state4$viewData$work2.value, _state4.viewData.selectedRows).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value6;
            successfulIds.push(_state4.viewData.selectedRows[idx]);
            var responseMessage = (response === null || response === void 0 || (_response$value6 = response.value) === null || _response$value6 === void 0 ? void 0 : _response$value6.message) || "System deleted successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to delete one or more systems");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "delete-row",
            payload: {
              ids: successfulIds
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state4.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "approve-single-entity") {
    var _state5 = AdminViewStore.getRawState();
    if (_state5.view === "users") {
      var _state5$viewData$work;
      approveUsers((_state5$viewData$work = _state5.viewData.workspace) === null || _state5$viewData$work === void 0 ? void 0 : _state5$viewData$work.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value7;
            successfulIds.push(action.payload.id);
            var responseMessage = (response === null || response === void 0 || (_response$value7 = response.value) === null || _response$value7 === void 0 ? void 0 : _response$value7.message) || "User approved successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve user");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          reducer({
            type: "mark-items-seen",
            payload: {
              ids: successfulIds,
              view: "users"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state5.viewData.currentPage;
          });
        }
      });
    } else if (_state5.view === "machines") {
      var _state5$viewData$work2;
      approveMachines((_state5$viewData$work2 = _state5.viewData.workspace) === null || _state5$viewData$work2 === void 0 ? void 0 : _state5$viewData$work2.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value8;
            successfulIds.push(action.payload.id);
            var responseMessage = (response === null || response === void 0 || (_response$value8 = response.value) === null || _response$value8 === void 0 ? void 0 : _response$value8.message) || "System approved successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to approve machine");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "APPROVED"
            }
          });
          reducer({
            type: "mark-items-seen",
            payload: {
              ids: successfulIds,
              view: "machines"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state5.viewData.currentPage;
          });
        }
      });
    }
  } else if (action.type === "revoke-single-entity") {
    var _state6 = AdminViewStore.getRawState();
    if (_state6.view === "users") {
      var _state6$viewData$work;
      revokeUsers((_state6$viewData$work = _state6.viewData.workspace) === null || _state6$viewData$work === void 0 ? void 0 : _state6$viewData$work.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value9;
            successfulIds.push(action.payload.id);
            var responseMessage = (response === null || response === void 0 || (_response$value9 = response.value) === null || _response$value9 === void 0 ? void 0 : _response$value9.message) || "User rejected successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject user");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state6.viewData.currentPage;
          });
          reducer({
            type: "mark-items-seen",
            payload: {
              ids: successfulIds,
              view: "users"
            }
          });
        }
      });
    } else if (_state6.view === "machines") {
      var _state6$viewData$work2;
      revokeMachines((_state6$viewData$work2 = _state6.viewData.workspace) === null || _state6$viewData$work2 === void 0 ? void 0 : _state6$viewData$work2.value, [action.payload.id]).then(function (responses) {
        var hasAtleastOneFailedResponse = false;
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value0;
            successfulIds.push(action.payload.id);
            var responseMessage = (response === null || response === void 0 || (_response$value0 = response.value) === null || _response$value0 === void 0 ? void 0 : _response$value0.message) || "System rejected successfully";
            Toast.success(responseMessage);
          } else {
            hasAtleastOneFailedResponse = true;
          }
        });
        if (hasAtleastOneFailedResponse) {
          Toast.error("Failed to reject machine");
        }
        if (successfulIds.length !== 0) {
          reducer({
            type: "reset"
          });
          // reducer({ type: "get-data" });
          reducer({
            type: "update-row",
            payload: {
              ids: successfulIds,
              nextState: "REJECTED"
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state6.viewData.currentPage;
          });
        }
        reducer({
          type: "mark-items-seen",
          payload: {
            ids: successfulIds,
            view: "machines"
          }
        });
      });
    }
  } else if (action.type === "delete-single-entity") {
    var _state7 = AdminViewStore.getRawState();
    if (_state7.view === "users") {
      var _state7$viewData$work;
      deleteUsers((_state7$viewData$work = _state7.viewData.workspace) === null || _state7$viewData$work === void 0 ? void 0 : _state7$viewData$work.value, [action.payload.id]).then(function (responses) {
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value1;
            successfulIds.push(action.payload.id);
            var responseMessage = (response === null || response === void 0 || (_response$value1 = response.value) === null || _response$value1 === void 0 ? void 0 : _response$value1.message) || "User deleted successfully";
            Toast.success(responseMessage);
          } else {
            var _response$reason;
            var errorMessage = (response === null || response === void 0 || (_response$reason = response.reason) === null || _response$reason === void 0 || (_response$reason = _response$reason.response) === null || _response$reason === void 0 || (_response$reason = _response$reason.data) === null || _response$reason === void 0 ? void 0 : _response$reason.message) || "Failed to delete user";
            Toast.error(errorMessage);
          }
        });
        if (successfulIds.length !== 0) {
          reducer({
            type: "delete-row",
            payload: {
              ids: successfulIds
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state7.viewData.currentPage;
          });
          reducer({
            type: "mark-items-seen",
            payload: {
              ids: successfulIds,
              view: "users"
            }
          });
        }
      });
    } else if (_state7.view === "machines") {
      var _state7$viewData$work2;
      deleteMachines((_state7$viewData$work2 = _state7.viewData.workspace) === null || _state7$viewData$work2 === void 0 ? void 0 : _state7$viewData$work2.value, [action.payload.id]).then(function (responses) {
        var successfulIds = [];
        responses.forEach(function (response, idx) {
          if (response.status === "fulfilled") {
            var _response$value10;
            successfulIds.push(action.payload.id);
            var responseMessage = (response === null || response === void 0 || (_response$value10 = response.value) === null || _response$value10 === void 0 ? void 0 : _response$value10.message) || "System deleted successfully";
            Toast.success(responseMessage);
          } else {
            var _response$reason2;
            var errorMessage = (response === null || response === void 0 || (_response$reason2 = response.reason) === null || _response$reason2 === void 0 || (_response$reason2 = _response$reason2.response) === null || _response$reason2 === void 0 || (_response$reason2 = _response$reason2.data) === null || _response$reason2 === void 0 ? void 0 : _response$reason2.message) || "Failed to delete system";
            Toast.error(errorMessage);
          }
        });
        if (successfulIds.length !== 0) {
          reducer({
            type: "delete-row",
            payload: {
              ids: successfulIds
            }
          });
          updateWithRecompute(function (s) {
            s.viewData.currentPage = _state7.viewData.currentPage;
          });
          reducer({
            type: "mark-items-seen",
            payload: {
              ids: successfulIds,
              view: "machines"
            }
          });
        }
      });
    }
  } else if (action.type === "reset") {
    updateWithRecompute(function (s) {
      // s.data = null;
      s.viewData = _objectSpread(_objectSpread({}, s.viewData), {}, {
        allRowsSelected: false,
        selectedRows: [],
        currentPage: 1
      });
    });
  } else if (action.type === "next-page") {
    var _state8 = AdminViewStore.getRawState();
    updateWithRecompute(function (s) {
      if (hasNextPage(_state8)) {
        s.viewData.currentPage += 1;
      }
    });
  } else if (action.type === "prev-page") {
    var _state9 = AdminViewStore.getRawState();
    updateWithRecompute(function (s) {
      if (hasPrevPage(_state9)) {
        s.viewData.currentPage -= 1;
      }
    });
  } else if (action.type === "first-page") {
    updateWithRecompute(function (s) {
      s.viewData.currentPage = 1;
    });
  } else if (action.type === "last-page") {
    var _state0 = AdminViewStore.getRawState();
    if (!_state0.data) {
      return;
    }
    var lastPage = Math.ceil(_state0.computed.filteredCount / _state0.viewData.maxRowsPerPage);
    updateWithRecompute(function (s) {
      s.viewData.currentPage = lastPage;
    });
  } else if (action.type === "update-row") {
    var _state1 = AdminViewStore.getRawState();
    var newData = _state1.data[_state1.view].map(function (item) {
      var newItem = _objectSpread({}, item);
      if (action.payload.ids.includes(newItem.id)) {
        newItem.approved = action.payload.nextState;
        return newItem;
      }
      return newItem;
    });
    updateWithRecompute(function (s) {
      s.data = _objectSpread(_objectSpread({}, s.data), {}, _defineProperty({}, s.view, newData));
    });
    if (_state1.view === "users") {
      reducer({
        type: "mark-items-seen",
        payload: {
          ids: action.payload.ids,
          view: "users"
        }
      });
    } else if (_state1.view === "machines") {
      reducer({
        type: "mark-items-seen",
        payload: {
          ids: action.payload.ids,
          view: "machines"
        }
      });
    }
  } else if (action.type === "delete-row") {
    var _state10$data$_state;
    var _state10 = AdminViewStore.getRawState();
    if (!_state10.data) {
      return;
    }
    var _newData = [];
    (_state10$data$_state = _state10.data[_state10.view]) === null || _state10$data$_state === void 0 || _state10$data$_state.forEach(function (item) {
      if (!action.payload.ids.includes(item.id)) {
        _newData.push(item);
      }
    });
    var newSelectedRows = _state10.viewData.selectedRows.filter(function (id) {
      return !action.payload.ids.includes(id);
    });
    updateWithRecompute(function (s) {
      s.data = _objectSpread(_objectSpread({}, s.data), {}, _defineProperty({}, s.view, _newData));
      s.viewData = _objectSpread(_objectSpread({}, s.viewData), {}, {
        selectedRows: newSelectedRows,
        allRowsSelected: false
      });
    });
    if (_state10.view === "users") {
      reducer({
        type: "mark-items-seen",
        payload: {
          ids: action.payload.ids,
          view: "users"
        }
      });
    } else if (_state10.view === "machines") {
      reducer({
        type: "mark-items-seen",
        payload: {
          ids: action.payload.ids,
          view: "machines"
        }
      });
    }
  } else if (action.type === "set-status-filter") {
    updateWithRecompute(function (s) {
      s.filters.status = action.payload.statuses;
      s.viewData.currentPage = 1;
      s.metadata.isDirty = true;
    });
  } else if (action.type === "set-search-filter") {
    updateWithRecompute(function (s) {
      s.filters.search[action.payload.field] = action.payload.value;
      s.viewData.currentPage = 1;
      s.metadata.isDirty = true;
    });
  } else if (action.type === "set-sorting") {
    updateWithRecompute(function (s) {
      s.filters.sorting.field = action.payload.field;
      s.filters.sorting.direction = action.payload.direction;
      s.viewData.currentPage = 1;
      s.metadata.isDirty = true;
    });
  } else if (action.type === "start-polling") {
    var _workspace2 = action.payload.workspace;
    if (_workspace2) {
      realTimeManager.start(_workspace2, reducer);
    }
  } else if (action.type === "stop-polling") {
    realTimeManager.stop();
  } else if (action.type === "mark-items-seen") {
    var _action$payload2 = action.payload,
      ids = _action$payload2.ids,
      view = _action$payload2.view;
    updateWithRecompute(function (s) {
      if (view === "users") {
        ids.forEach(function (id) {
          return s.realtime.highlightedUsers["delete"](id);
        });
        s.realtime.newUsersCount = s.realtime.highlightedUsers.size;
      } else if (view === "machines") {
        ids.forEach(function (id) {
          return s.realtime.highlightedMachines["delete"](id);
        });
        s.realtime.newMachinesCount = s.realtime.highlightedMachines.size;
      }
    });
  }
}
function applyFilters(data, filters) {
  if (!data) return [];
  return data.filter(function (item) {
    var _item$system_details;
    if (filters.status.length > 0 && !filters.status.includes(item.approved)) {
      return false;
    }

    // For users view: search in both username and email with the username filter
    if (filters.search.userquery && filters.search.userquery.trim() !== "") {
      var _item$username, _item$email;
      var query = filters.search.userquery.toLowerCase();
      var matchesUsername = (_item$username = item.username) === null || _item$username === void 0 ? void 0 : _item$username.toLowerCase().includes(query);
      var matchesEmail = (_item$email = item.email) === null || _item$email === void 0 ? void 0 : _item$email.toLowerCase().includes(query);

      // If neither username nor email matches, filter out this item
      if (!matchesUsername && !matchesEmail) {
        return false;
      }
    }

    // For machines view: search by hostname
    if (filters.search.hostname && !(item !== null && item !== void 0 && (_item$system_details = item.system_details) !== null && _item$system_details !== void 0 && (_item$system_details = _item$system_details.hostname) !== null && _item$system_details !== void 0 && _item$system_details.toLowerCase().includes(filters.search.hostname.toLowerCase()))) {
      return false;
    }
    return true;
  });
}
function applySorting(data, sorting) {
  if (!data) return [];
  return _toConsumableArray(data).sort(function (a, b) {
    var aValue, bValue;

    // Handle special field mappings
    if (sorting.field === "lastLogin") {
      aValue = a["last_login_attempt"];
      bValue = b["last_login_attempt"];
    } else {
      aValue = a[sorting.field];
      bValue = b[sorting.field];
    }

    // Handle date fields
    if (sorting.field === "lastLogin" || sorting.field === "createdAt") {
      // Handle empty/null dates (treat as very old dates for sorting)
      if (!aValue || aValue === "NA" || aValue === "") aValue = "1970-01-01";
      if (!bValue || bValue === "NA" || bValue === "") bValue = "1970-01-01";
      aValue = new Date(aValue).getTime();
      bValue = new Date(bValue).getTime();
    } else if (typeof aValue === "string" && typeof bValue === "string") {
      var _aValue, _bValue;
      aValue = (_aValue = aValue) === null || _aValue === void 0 ? void 0 : _aValue.toLowerCase();
      bValue = (_bValue = bValue) === null || _bValue === void 0 ? void 0 : _bValue.toLowerCase();
    }
    if (aValue > bValue) {
      return sorting.direction === "asc" ? 1 : -1;
    }
    if (aValue < bValue) {
      return sorting.direction === "asc" ? -1 : 1;
    }
    return 0;
  });
}
function applyPagination(data, currentPage, maxRowsPerPage) {
  if (!data) return [];
  var startIndex = (currentPage - 1) * maxRowsPerPage;
  var endIndex = startIndex + maxRowsPerPage;
  return _toConsumableArray(data).slice(startIndex, endIndex);
}
function useAdminView() {
  var state = AdminViewStore.useState(function (s) {
    return s;
  });
  return [state, reducer];
}
export default useAdminView;